var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8731_426)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2 0H3.2C1.44 0 0 1.44 0 3.2V11.2C0 12.96 1.44 14.4 3.2 14.4H11.2C12.96 14.4 14.4 12.96 14.4 11.2V3.2C14.4 1.44 12.96 0 11.2 0ZM11.2 11.2H3.2V3.2H11.2V11.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2 17.6001H3.2C1.44 17.6001 0 19.0401 0 20.8001V28.8001C0 30.5601 1.44 32.0001 3.2 32.0001H11.2C12.96 32.0001 14.4 30.5601 14.4 28.8001V20.8001C14.4 19.0401 12.96 17.6001 11.2 17.6001ZM11.2 28.8001H3.2V20.8001H11.2V28.8001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8 0H20.8C19.04 0 17.6 1.44 17.6 3.2V11.2C17.6 12.96 19.04 14.4 20.8 14.4H28.8C30.56 14.4 32 12.96 32 11.2V3.2C32 1.44 30.56 0 28.8 0ZM28.8 11.2H20.8V3.2H28.8V11.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8 17.6001H20.8C19.04 17.6001 17.6 19.0401 17.6 20.8001V28.8001C17.6 30.5601 19.04 32.0001 20.8 32.0001H28.8C30.56 32.0001 32 30.5601 32 28.8001V20.8001C32 19.0401 30.56 17.6001 28.8 17.6001ZM28.8 28.8001H20.8V20.8001H28.8V28.8001Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8731_426"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.8bc602e02975b868d5cb3e451a00c2d3.svg";
export { ForwardRef as ReactComponent };